/* Coallate datastructure classes for easy access */

const { AuthUser, authUserSchema } = require('./classes/authUser.class');
const { AuthRefreshToken, authRefreshTokenSchema } = require('./classes/authRefreshToken.class');
const { AuthForgotPasswordToken, authForgotPasswordTokenSchema } = require('./classes/authForgotPassowordToken.class');
const { AuthSessionToken, authSessionTokenSchema } = require('./classes/authSessionToken.class');
const { AccountSetting, accountSettingSchema } = require('./classes/accountSetting.class');
const { Address, addressSchema } = require('./classes/address.class');
const { Annotation, annotationSchema } = require('./classes/annotation.class');
const { BodySite, bodySiteSchema } = require('./classes/bodySite.class');
const { BodySiteAnnotation, bodySiteAnnotationSchema } = require('./classes/bodySiteAnnotation.class');
const { Eoc, eocSchema } = require('./classes/eoc.class');
const { EocAnnotation, eocAnnotationSchema } = require('./classes/eocAnnotation.class');
const { Channel, channelSchema } = require('./classes/channel.class');
const { ClinicalImpression, clinicalImpressionSchema } = require('./classes/clinicalImpression.class');
const { ClinicalImpressionAnnotation, clinicalImpressionAnnotationSchema } = require('./classes/clinicalImpressionAnnotation.class');
const { Code, codeSchema } = require('./classes/code.class');
const { Condition, conditionSchema } = require('./classes/condition.class');
const { ConditionAnnotation, conditionAnnotationSchema } = require('./classes/conditionAnnotation.class');
const { ContactPoint, contactPointSchema } = require('./classes/contactPoint.class');
const { Diagnosis, diagnosisSchema } = require('./classes/diagnosis.class');
const { Evidence, evidenceSchema } = require('./classes/evidence.class');
const { Image, imageSchema } = require('./classes/image.class');
const { ImageAnnotation, imageAnnotationSchema } = require('./classes/imageAnnotation.class');
const { Finding, findingSchema } = require('./classes/finding.class');
const { ImageSet, imageSetSchema } = require('./classes/imageSet.class');
const { Investigation, investigationSchema } = require('./classes/investigation.class');
const { Message, messageSchema } = require('./classes/message.class');
const { OrgAdmin, orgAdminSchema } = require('./classes/orgAdmin.class');
const { Organization, organizationSchema } = require('./classes/organization.class');
const { OrgTag, orgTagSchema } = require('./classes/orgTag.class');
const { OrgsIndex, orgsIndexSchema } = require('./classes/orgsIndex.class');
const { OrgsToEocs, orgsToEocsSchema } = require('./classes/orgsToEocs.class');
const { OrgsToUsers, orgsToUsersSchema } = require('./classes/orgsToUsers.class');
const { Patient, patientSchema } = require('./classes/patient.class');
const { ProviderAP, providerAPSchema } = require('./classes/providerAP.class');
const { ProviderLP, providerLPSchema } = require('./classes/providerLP.class');
const { Reference, referenceSchema } = require('./classes/reference.class');
const { User, userSchema } = require('./classes/user.class');
const { UserTag, userTagSchema } = require('./classes/userTag.class');
const { UserQualification, userQualificationSchema } = require('./classes/userQualification.class');
const { Schedule, scheduleSchema } = require('./classes/schedule.class');
const { Slot, slotSchema } = require('./classes/slot.class');
const { Stage, stageSchema } = require('./classes/stage.class');
const { UsersIndex, usersIndexSchema } = require('./classes/usersIndex.class');
const { UsersToEocs, usersToEocsSchema } = require('./classes/usersToEocs.class');
const { UsersToChannels, usersToChannelsSchema } = require('./classes/usersToChannels.class');
const { UsersToWorkspaces, usersToWorkspacesSchema } = require('./classes/usersToWorkspaces.class');
const { UserWebsocketsConnection, userWebsocketsConnectionSchema } = require('./classes/userWebsocketsConnection.class');
const { Workspace, workspaceSchema } = require('./classes/workspace.class');
const { WebRtcRoom, webRtcRoomSchema } = require('./classes/webRtcRoom.class');
const { Team, teamSchema } = require('./classes/team.class');
const { EocsToTeams, eocsToTeamsSchema } = require('./classes/eocsToTeams.class');
const { UsersToTeams, usersToTeamsSchema } = require('./classes/usersToTeams.class');
const { ConferenceRoom, conferenceRoomSchema } = require('./classes/conferenceRoom.class');
const { ConferenceRoomTranscript, conferenceRoomTranscriptSchema } = require('./classes/conferenceRoomTranscript.class');
const { UsersToConferenceRooms, usersToConferenceRoomsSchema } = require('./classes/usersToConferenceRooms.class');
const { Branding, brandingSchema } = require('./classes/branding.class');
const { OrgConfig, orgConfigSchema } = require('./classes/orgConfig.class');
const { Notification, notificationSchema } = require('./classes/notification.class');
const { DictationRoom, dictationRoomSchema } = require('./classes/dictationRoom.class');
const { PageTag, pageTagSchema } = require('./classes/pageTag.class');
const { BookTag, bookTagSchema } = require('./classes/bookTag.class');
const { LibraryTag, libraryTagSchema } = require('./classes/libraryTag.class');
const { Library, librarySchema } = require('./classes/library.class');
const { Book, bookSchema } = require('./classes/book.class');
const { Page, pageSchema } = require('./classes/page.class');
const { UsersToPages, usersToPagesSchema } = require('./classes/usersToPages.class');
const { UsersToBooks, usersToBooksSchema } = require('./classes/usersToBooks.class');
const { UsersToLibraries, usersToLibrariesSchema } = require('./classes/usersToLibraries.class');
const { TeamsToPages, teamsToPagesSchema } = require('./classes/teamsToPages.class');
const { TeamsToBooks, teamsToBooksSchema } = require('./classes/teamsToBooks.class');
const { TeamsToLibraries, teamsToLibrariesSchema } = require('./classes/teamsToLibraries.class');
const { EocsToPages, eocsToPagesSchema } = require('./classes/eocsToPages.class');
const { EocsToBooks, eocsToBooksSchema } = require('./classes/eocsToBooks.class');
const { EocsToLibraries, eocsToLibrariesSchema } = require('./classes/eocsToLibraries.class');
const { OrgsToPages, orgsToPagesSchema } = require('./classes/orgsToPages.class');
const { OrgsToBooks, orgsToBooksSchema } = require('./classes/orgsToBooks.class');
const { OrgsToLibraries, orgsToLibrariesSchema } = require('./classes/orgsToLibraries.class');
const { PagesToBooks, pagesToBooksSchema } = require('./classes/pagesToBooks.class');
const { PagesToLibraries, pagesToLibrariesSchema } = require('./classes/pagesToLibraries.class');
const { BooksToLibraries, booksToLibrariesSchema } = require('./classes/booksToLibraries.class');
const { EocExportRecord, eocExportRecordSchema } = require('./classes/eocExportRecord.class');
const { CalendarObject, calendarObjectSchema } = require('./classes/calendarObject.class');
const { UsersToCalendarObjects, usersToCalendarObjectsSchema } = require('./classes/usersToCalendarObjects.class');
const { UserPin, userPinSchema } = require('./classes/userPin.class');
const { UserWalkthrough, userWalkthroughSchema } = require('./classes/userWalkthrough.class');

const DataClasses = {
  AuthUser,
  AuthRefreshToken,
  AuthForgotPasswordToken,
  AuthSessionToken,
  AccountSetting,
  Address,
  Annotation,
  BodySite,
  BodySiteAnnotation,
  Eoc,
  EocAnnotation,
  Channel,
  ClinicalImpression,
  ClinicalImpressionAnnotation,
  Code,
  Condition,
  ConditionAnnotation,
  ContactPoint,
  Diagnosis,
  Evidence,
  Image,
  ImageAnnotation,
  Finding,
  ImageSet,
  Investigation,
  Message,
  OrgAdmin,
  Organization,
  OrgsIndex,
  OrgsToEocs,
  OrgsToUsers,
  OrgTag,
  Patient,
  ProviderAP,
  ProviderLP,
  Reference,
  User,
  UserTag,
  UserQualification,
  Schedule,
  Slot,
  Stage,
  UsersIndex,
  UsersToEocs,
  UsersToChannels,
  UsersToWorkspaces,
  UserWebsocketsConnection,
  Workspace,
  WebRtcRoom,
  Team,
  EocsToTeams,
  UsersToTeams,
  PageTag,
  BookTag,
  LibraryTag,
  Library,
  Book,
  Page,
  UsersToPages,
  UsersToBooks,
  UsersToLibraries,
  TeamsToPages,
  TeamsToBooks,
  TeamsToLibraries,
  EocsToPages,
  EocsToBooks,
  EocsToLibraries,
  OrgsToPages,
  OrgsToBooks,
  OrgsToLibraries,
  PagesToBooks,
  PagesToLibraries,
  BooksToLibraries,
  ConferenceRoom,
  ConferenceRoomTranscript,
  UsersToConferenceRooms,
  Branding,
  OrgConfig,
  Notification,
  DictationRoom,
  CalendarObject,
  UsersToCalendarObjects,
  EocExportRecord,
  UserPin,
  UserWalkthrough,
};

const dataSchemas = {
  authUserSchema,
  authRefreshTokenSchema,
  authForgotPasswordTokenSchema,
  authSessionTokenSchema,
  accountSettingSchema,
  addressSchema,
  annotationSchema,
  bodySiteSchema,
  bodySiteAnnotationSchema,
  eocSchema,
  eocAnnotationSchema,
  channelSchema,
  clinicalImpressionSchema,
  clinicalImpressionAnnotationSchema,
  codeSchema,
  conditionSchema,
  conditionAnnotationSchema,
  contactPointSchema,
  diagnosisSchema,
  evidenceSchema,
  imageSchema,
  imageAnnotationSchema,
  findingSchema,
  imageSetSchema,
  investigationSchema,
  messageSchema,
  orgAdminSchema,
  organizationSchema,
  orgTagSchema,
  orgsIndexSchema,
  orgsToEocsSchema,
  orgsToUsersSchema,
  patientSchema,
  providerAPSchema,
  providerLPSchema,
  referenceSchema,
  userSchema,
  userTagSchema,
  userQualificationSchema,
  scheduleSchema,
  slotSchema,
  stageSchema,
  usersIndexSchema,
  usersToEocsSchema,
  usersToChannelsSchema,
  usersToWorkspacesSchema,
  userWebsocketsConnectionSchema,
  workspaceSchema,
  webRtcRoomSchema,
  teamSchema,
  eocsToTeamsSchema,
  usersToTeamsSchema,
  pageTagSchema,
  bookTagSchema,
  libraryTagSchema,
  librarySchema,
  bookSchema,
  pageSchema,
  usersToPagesSchema,
  usersToBooksSchema,
  usersToLibrariesSchema,
  teamsToPagesSchema,
  teamsToBooksSchema,
  teamsToLibrariesSchema,
  eocsToPagesSchema,
  eocsToBooksSchema,
  eocsToLibrariesSchema,
  orgsToPagesSchema,
  orgsToBooksSchema,
  orgsToLibrariesSchema,
  pagesToBooksSchema,
  pagesToLibrariesSchema,
  booksToLibrariesSchema,
  conferenceRoomSchema,
  conferenceRoomTranscriptSchema,
  usersToConferenceRoomsSchema,
  brandingSchema,
  orgConfigSchema,
  notificationSchema,
  dictationRoomSchema,
  calendarObjectSchema,
  usersToCalendarObjectsSchema,
  eocExportRecordSchema,
  userPinSchema,
  userWalkthroughSchema,
};

exports.DataClasses = DataClasses;
exports.dataSchemas = dataSchemas;